<template>
  <div>
    <div class="green-inside">
      <!-- 插件swiper区域 -->
      <div>
        <swiper
          v-if="props.dataArr.length"
          direction="horizontal"
          class="inside-cardBox"
          :slidesPerView="props.dataArr.length >= 1 ? 1 : props.dataArr.length"
          loop
          :autoplay="{ delay: 3000, disableOnInteraction: true }"
          :navigation="false"
          :pagination="{ clickable: true }"
          :scrollbar="{ draggable: true }"
          :space-between="0"
          :centeredSlides="false"
          :modules="modules"
          effect="coverflow"
          @swiper="onSwiper"
          @mouseenter="enter"
          @mouseleave="leave"
          @slideChange="onSlideChange"
        >
          <swiper-slide
            v-for="(item, index) in props.dataArr"
            :key="index"
            class="book-cards"
            @click="swiperSlideClick(item)"
          >
            <columnBookCards class="column-book1" :img_txt="item.img_txt">
              <template #columnBook>
                <!-- <img
                  v-if="/^http/.test(item.img_url)"
                  class="big-img"
                  v-complete:src="item.img_url"
                />
                <img
                  v-else
                  class="big-img"
                  v-complete:src="item.img_url"
                /> -->
                 <img 
                  class="big-img"
                  v-complete:src="item.img_url"
                />
              </template>
            </columnBookCards>
          </swiper-slide>
        </swiper>
      </div>
      <!-- <el-button
        class="l-btn huibian"
        :icon="ArrowLeft"
        circle
        @click="rightClick"
      ></el-button>
      <el-button
        class="r-btn"
        :icon="ArrowRight"
        circle
        @click="leftClick"
      ></el-button> -->
    </div>
  </div>
</template>

<script setup>
import { toRaw, nextTick, reactive } from "vue";
import columnBookCards from "./components/columnBookCards/index.vue";
import { ArrowLeft, ArrowRight } from "@element-plus/icons-vue";
// 引入swiper插件
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import {
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper/modules";

// 创建功能模块
let modules = [Autoplay, Navigation, Pagination, Scrollbar, A11y];
//定义swiperNew,目的获取非响应式swiper
let swiperNew = null;
// 事件处理器
const onSwiper = (swiper) => {
  swiperNew = toRaw(swiper); //拿到swiper对象再转换为非响应式
};
//鼠标移入
const enter = () => {
  swiperNew.autoplay.stop();
};
//鼠标移出
const leave = () => {
  swiperNew.autoplay.start();
};
// 点击右箭头
const rightClick = () => {
  nextTick(() => {
    swiperNew.slidePrev();
  });
};
// 点击左箭头
const leftClick = () => {
  nextTick(() => {
    swiperNew.slideNext();
  });
};
// 单元块滑动
const onSlideChange = () => {};

const props = defineProps({
  dataArr: {
    type: Array,
    default: () => {
      return [];
    },
  },
});

const mydata = reactive({
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

const emits = defineEmits(["itemClick"]);

function swiperSlideClick(item) {
  emits("itemClick", item);
}
</script>

<style scoped lang="scss">
:deep(.myRowBookCards) {
  width: 100% !important;
}
.green-inside {
  width: 343px;
  // height: 300px;
  position: relative;
  margin: 0 auto;
  // border-radius: 8px;
  background: linear-gradient(
    110.52deg,
    rgba(246, 246, 250, 0.4) -1.14%,
    rgba(81, 83, 103, 0) 102.14%
  );
  display: flex;
  flex-direction: column;
  border:1px solid transparent;
  // border:1px solid blue;
  //////图书卡片组件
  .inside-cardBox {
    display: flex;
    .book-cards {
      margin: 0;
    }
    .column-book1 {
      // width: 367px;
      display: block;
      height: 100% !important;
      // margin: 0px 17px;
      flex-shrink: 0;
      // border:1px solid red;
      //  box-shadow:2px 2px 4px #c5cbce90;
      .big-img {
        width:341px;
        height:201px;
        display: block;
        // height: 336px;
        // border:1px solid red;
      }
      .box-content{
        // padding-bottom:10px;
        >p:hover{
          color: #009de0 !important;
        }
      }
    }
  }
}
:deep(.swiper-wrapper) {
  // width: 365px;
  height: 285px !important;
}


:deep(.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal){
  display: none;
}


.l-btn {
  position: absolute;
  z-index: 9999;
  color: #ccc;
  font-size: 20px;
  border: 1px solid #ccc;
  width: 25px !important;
  height: 25px !important;
  border-radius: 100%;
  line-height: 25px;
  text-align: center;
  top: 45%;
  left: -50px;
  background: transparent;
}
.r-btn {
  position: absolute;
  z-index: 9999;
  color: #ccc;
  font-size: 20px;
  border: 1px solid #ccc;
  width: 25px !important;
  height: 25px !important;
  border-radius: 100%;
  line-height: 25px;
  text-align: center;
  top: 45%;
  right: -50px;
  background: transparent;
}
</style>
